'Null'.datatype()
